export const enum Roles {
  SUPER_ADMIN = 'super_admin',
  MERCHANT = 'merchant',
  CONSUMER = 'consumer',
}

export const SUPER_ADMIN_ENTITY_ID = "SUPER_ADMINISTRATOR";